export default {
	name: 'ឈ្មោះ',
	gender: 'ភេទ',
	dob: 'ថ្ងៃខែ​ឆ្នាំ​កំណើត',
	phone: 'ទូរស័ព្ទ',
	new_doctor: 'វេជ្ជបណ្ឌិតថ្មី',
	update_doctor: 'កែប្រែវេជ្ជបណ្ឌិត',
	commission: 'គណៈកម្មការ'
};
